<template>
        <div class="col-sm-3 pb-3 entity-row-6" >
            <img class="img-fluid" v-bind:src="this.cmsUrl + image.image.image_url" v-bind:alt="image.image.alt_text">
        </div>
</template>

<script>

    export default {
        props: ['image'],
    }
</script>